module.exports = __webpack_public_path__ + "static/img/xiaojie.e8410fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login/xiaojie.png
// module id = 0lQe
// module chunks = 2